
















































































































































































import {Vue, Component} from "vue-property-decorator";

@Component
export default class Terms extends Vue {
}
